import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { crmApi, type Customer } from '../../api/crm';

export function CustomerDirectoryPage() {
  const [items, setItems] = useState<Customer[]>([]);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    void crmApi.listCustomers().then(setItems);
  }, []);

  async function createSample() {
    await crmApi.createCustomer({
      account_type: 'individual', email: 'new@example.com',
      first_name: 'Arjun', last_name: 'Mehta', marketplace: 'amazon', external_id: 'AMZ-999',
    });
    setMsg('Customer created');
    setItems(await crmApi.listCustomers());
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/customers" className="text-sm text-slate-600 hover:underline">← CRM hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Customer directory</h1>
      {msg && <p className="mt-2 text-sm text-green-700">{msg}</p>}
      <button type="button" onClick={() => void createSample()}
        className="mt-4 rounded-lg bg-slate-900 px-4 py-2 text-sm text-white">Create sample customer</button>
      <ul className="mt-6 space-y-2">
        {items.map((c) => (
          <li key={c.id} className="rounded border p-3 text-sm">
            {c.customer_code} — {c.first_name} {c.last_name} · {c.email} · LTV ₹{c.lifetime_value} · {c.rfm_segment}
          </li>
        ))}
      </ul>
    </div>
  );
}
